import React, { Component } from 'react';
import Button from '../../../components/form/Button';
import { push } from 'react-router-redux';
import { styles } from '../index';
import Close from 'material-ui/svg-icons/navigation/close';
import Check from 'material-ui/svg-icons/navigation/check';
import { WorkingPositionHandoverProtocolType } from '../enum';
import { generateHandoverProtocolOfficialWorkingPosition } from "../CroActions";
import * as moment from 'moment';

export default (Comp) => (
  class LoginInfoComponent extends Component {

    onShow = () => () => {
      this.props.dispatch(push({ pathname: window.location.pathname, query: { q: 'importResults' } }))
    }

    handleHandoverProtocol = (official, type) => {
      let wpId = official.workingPosition ? official.workingPosition.id : null;
      generateHandoverProtocolOfficialWorkingPosition(official.id, wpId, type, this.props.dispatch)
    }

    writeLine = (login, index) => {
      const style = login.error.includes('Chyba') ? { color: '#df2424' } : { color: 'green'};
      const formattedBirthDate = login.birthDate ? moment(login.birthDate).locale('cs').format('D.M.YYYY') : '';
      const buttonStyle = { whiteSpace: 'nowrap' };

      if (!login.error.includes('Chyba'))
        return <tr key={index}><td><Check style={style}/></td><td>{login.firstName}</td><td>{login.lastName}</td><td>{formattedBirthDate}</td><td>{login.username}</td><td>{login.password}</td><td>{login.error}</td>
          <td>
            <div className="actions">
            <Button
              type="button"
              style={{ ...styles.buttons, ...buttonStyle }}
              label="Předávací protokol (vstupní)"
              onClick={() => this.handleHandoverProtocol(login, WorkingPositionHandoverProtocolType.INGOING_STATEMENT)}
            />
            {login.workingPosition && login.workingPosition.end && (
              <Button
                type="button"
                style={{ ...styles.buttons, ...buttonStyle }}
                label="Předávací protokol (výstupní)"
                onClick={() => this.handleHandoverProtocol(login, WorkingPositionHandoverProtocolType.OUTGOING_STATEMENT)}
              />
            )}
            </div>
          </td>
        </tr>
      else
        return <tr key={index} style={style}><td><Close style={style}/></td><td>{login.firstName}</td><td>{login.lastName}</td><td>{formattedBirthDate}</td><td>{login.username}</td><td>{login.password}</td><td>{login.error}</td><td></td></tr>

    }

    writeTable = (loginArray) => {
      return (
        <div>
          <p>Po uzavření tohoto reportu budou uživatelská jména a hesla přístupná jen v jednotlivých kartách veřejných funkcionářů.</p>
          <table className='loginTable'>
            <tbody>
              <tr><th>Stav</th><th>Jméno</th><th>Příjmení</th><th>Datum narození</th><th>Uživ. jméno</th><th>Heslo</th><th>Poznámka</th><th>Akce</th></tr>
              {loginArray.map((login, index) => this.writeLine(login, index))}
            </tbody>
          </table>
        </div>
      )
    }

    back = () => {
      this.props.router.goBack();
    }

    infoStyle = show => show ? { paddingBottom: 20 } : { display: 'none' }

    render() {
      const dataName = 'import_officials';

      const { location: { query } } = this.props;
      const importResults = JSON.parse(window.sessionStorage.getItem(dataName));
      const show = query.q === 'importResults';

      return (
        <div>
          <div style={this.infoStyle(!show)}>
            <Comp {...this.props} getLoginInfo={this.onShow} dataName={dataName} />
          </div>

          <div style={this.infoStyle(show)}>
            <p className="cro-ask-question-p" style={{ marginLeft: 0, ...(importResults ? { color: 'green' } : { color: 'red' }) }}>
              {importResults ? 'Importovaný soubor byl úspěšně zpracován.' : 'Importovaný soubor se nepodařilo načíst.'}
            </p>
            {importResults ? this.writeTable(importResults) : <p>Špatný formát dat v importním souboru.</p>}
            <Button type="button" style={styles.buttons} label="Zpět" onClick={this.back} />
          </div>
        </div>
      )
    }
  }
)
